// deno-lint-ignore-file ban-unused-ignore no-explicit-any no-empty-interface
///////////////////////////////////
// !!! DO NOT EDIT THIS FILE !!! //
///////////////////////////////////

import type { SlackAPIResponse } from "../response";
export type AdminAuthPolicyGetEntitiesResponse = SlackAPIResponse & {
  entities?: Entity[];
  entity_total_count?: number;
  error?: string;
  needed?: string;
  ok: boolean;
  provided?: string;
};

export interface Entity {
  date_added?: number;
  entity_id?: string;
  entity_type?: string;
}
